import { AddedValue } from '@cemex-core/cmx-api';
import { ProductRecommendation } from '@cemex-core/cmx-api/models/product/models/product-recommendation';

/**
 * Finds AddedValue objects matching @partials (ids)
 * @param partials [string, string] ids of value added to find
 * @param recommendations Entire product recommendations
 */
export function findAddedValuesFromIds(partials: string[], recommendations: ProductRecommendation[]) {
  const vaps: AddedValue[] = [];
  for (const recommendation of recommendations) {
    if (recommendation.valueAdded && recommendation.valueAdded.length) {
      // Has vaps, search for `toFind` values
      partials.forEach((vapId) => {
        // Only run the loop if the vapId is not already there in `vaps`
        if (!vaps.map((vap) => vap.family).includes(vapId)) {
          const vap = recommendation.valueAdded.find((item) => item.family === vapId);
          // If value added with same id found, push it into `vaps` array
          // Also delete it from partials to stop looking for it
          if (vap) {
            vaps.push(vap);
          }
        }
      });

      if (vaps.length === partials.length) {
        break;
      }
    }
  }

  return vaps;
}

/**
 * Finds AddedValue objects matching @partials (ids) to RMXUL
 * @param partials [string, string] ids of value added to find
 * @param recommendations Entire product recommendations
 */
export function findAddedValuesRMXULFromIds(partials: string[], recommendations: any[]) {
  const vaps: any[] = [];
  for (const recommendation of recommendations) {
    if (recommendation.valueAddeds && recommendation.valueAddeds.length) {
      // Has vaps, search for `toFind` values
      partials.forEach((vapId) => {
        // Only run the loop if the vapId is not already there in `vaps`
        if (!vaps.map((vap) => vap.valueAddedCode).includes(vapId)) {
          const vap = recommendation.valueAddeds.find((item) => item.valueAddedCode === vapId);
          // If value added with same id found, push it into `vaps` array
          // Also delete it from partials to stop looking for it
          if (vap) {
            vaps.push(vap);
          }
        }
      });
      if (vaps.length === partials.length) {
        break;
      }
    }
  }
  return vaps;
}
